import { useState } from "react";
import { message } from "antd";
import { ModalPortal } from "../../../../../../common/components/modalPortal/modalPortal";
import { EditIconButton } from "../../../../../../common/components/iconButton/editIconButton";
import { EditStartDateModal } from "./editStartDateModal";
import CommissionPlan from "../../../../../../redux/models/commissionPlan";

export const EditStartDateButton = ({
  commissionId,
  lastRuleStartDate,
  startDate,
  onSuccess,
}) => {
  const [loading, setLoading] = useState(false);

  const onFinish = (closeModal) => async (values) => {
    setLoading(true);

    const payload = {
      startDate: values.startDate.unix(),
    };

    try {
      await CommissionPlan.v2.editCurrentCommissionTimeline(
        commissionId,
        payload,
        false,
      );

      message.success("Default rule updated successfully");
      onSuccess?.(payload.startDate);
      closeModal();
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalPortal
      renderTrigger={(props) => (
        <EditIconButton showTooltip={false} {...props} />
      )}
    >
      {({ open, closeModal }) => (
        <EditStartDateModal
          open={open}
          loading={loading}
          onCancel={closeModal}
          onFinish={onFinish(closeModal)}
          lastRuleStartDate={lastRuleStartDate}
          startDate={startDate}
        />
      )}
    </ModalPortal>
  );
};
